// extracted by mini-css-extract-plugin
export default {"wrap":"InputNumberStep_wrap__2hs2F","number":"InputNumberStep_number__ZLmjz"};